import { Chip } from "@mui/material";
import _ from "lodash";
import React from "react";

import { competitorDelete } from "../../../services/api/competitor.js";
import { models } from "../../../services/enums/index.js";
import { createUserDisplayName } from "../../../services/utils/index.js";
import { ItemFooter, ItemHeaderWithHighlight } from "../../shared/other/index.js";
import { ModelItemTemplate } from "../../shared/templates/index.js";
import Body from "./_body.js";

export default React.memo(({
  item, highlight = [], callback, use,
}) => (
  <ModelItemTemplate
    inModal={_.isFunction(use)}
    header={<ItemHeaderWithHighlight name={createUserDisplayName(item.competitor)} highlight={highlight} />}
    body={<Body item={item} highlight={highlight} />}
    footer={(
      <ItemFooter
        item={item}
        callback={callback}
        use={use}
        model={models.COMPETITOR}
        modelDelete={competitorDelete}
        chip={_.isNil(item.competitionCategory)
          ? null
          : <Chip padding="0" color="info" size="small" label={item.competitionCategory} />}
      />
    )}
  />
));
